import {Component, Inject, Input, OnInit, Optional} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DeviceDetectService} from "../../../../services/device-detect.service";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import { NgClass, NgOptimizedImage } from "@angular/common";
import {appearSlowlyAnimation} from "../../../cookie-modal/cookie-modal-animation";
import {environment} from "../../../../../environments/environment";
import {SessionContext} from "../../../../models/session-context.model";
import {Router} from "@angular/router";
import {TermsText} from "../../../../services/contact-info.service";
import {BeforeLoginService} from "../../../../services/before-login.service";
import {LinkHandlerDirective} from "../../../../directives/link-handler.directive";

enum ClosureType {
  CONSENT_REMOVED = "consentRemoved",
  CANCEL_BUTTON_PRESSED = "cancelButtonPressed",
}

@Component({
  selector: "app-warning-modal",
  templateUrl: "./warning-modal.component.html",
  styleUrls: ["./warning-modal.component.css"],
  animations: [appearSlowlyAnimation],
  imports: [TranslateModule, NgOptimizedImage, NgClass, LinkHandlerDirective]
})

export class WarningModalComponent implements OnInit {
  private readonly PRESCRIPTION_CHECKBOX = "prescriptionConsent"
  @Input() content: string;
  @Input() checkboxName: string;
  expandText: boolean = false;
  isMobile: boolean;
  previousCheckboxState: boolean; // add this line
  termsText: TermsText;
  ntTakeBackConsentUrl = environment.consentService.takeBackConsentUrl;
  sessionContext: SessionContext = JSON.parse(
    sessionStorage.getItem("sessionContext"),
  );
  selectedLang: string = "et";


  constructor(
    private dialogRef: MatDialogRef<WarningModalComponent>,
    private deviceDetectService: DeviceDetectService,
    private router: Router,
    private beforeLoginService: BeforeLoginService,
    private translate: TranslateService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: {
      content: string,
      previousCheckboxState: boolean,
      checkboxName: string
    },
  ) {
    this.previousCheckboxState = data.previousCheckboxState || false;

  }

  ngOnInit(): void {
    this.selectedLang = this.translate.currentLang;
    this.isMobile = this.deviceDetectService.isMobile;
    this.checkboxName = this.data.checkboxName;
    this.content = this.data.content;
    this.beforeLoginService
      .fetchTerms(this.selectedLang, "PRESCRIPTION_CONSENT")
      .then((data) => {
        if (data && data.body) {
          this.termsText = data.body;
        }
      });
  }

  onRemove() {
    this.termsText.accepted = false;
      this.handleRedirect();
    this.closeModal(ClosureType.CONSENT_REMOVED, this.termsText);
  }

  onCancel() {
    this.closeModal(ClosureType.CANCEL_BUTTON_PRESSED);
  }

  closeModal(closureType: ClosureType, termsText?: TermsText) {
    this.dialogRef.close({closureType, accept: closureType === ClosureType.CANCEL_BUTTON_PRESSED, termsText});
  }

  handleRedirect() {
    if (this.checkboxName === this.PRESCRIPTION_CHECKBOX) {
      window.open(this.ntTakeBackConsentUrl);
    }
  }
}
